export default function ErrorAlert(props) {
    return (
        <div className="alert alert-danger text-break mb-0" role="alert">
            {props.message}
        </div>
    )
}